import {
  Pipe,
  PipeTransform,
  inject,
} from '@angular/core';
import {AppTranslateService} from '../../services/infrastructure/page/i18n/translate/app-translate/app-translate.service';
import {IInterviewManageAnswerGccVersionItem} from '../../models/insurer.model';

@Pipe({
  name: 'gccVersionTitle',
})
export class GccVersionTitlePipe implements PipeTransform {

  private appTranslateService = inject(AppTranslateService);

  transform(value: IInterviewManageAnswerGccVersionItem): string {
    const name = value?.documentTitle || this.appTranslateService.getTranslation('front.sng.title.empty.value');
    const date = value?.issueDate || this.appTranslateService.getTranslation('front.sng.title.empty.value');
    return `${date} ${name}`;
  }

}
